import { MAX_ALLOWED_INT } from 'src/shared/constants/constants'

const validateValue = (value: number): boolean => {
  // the only way the user can have NaN in the Grid is if the user deleted the whole content inside a cell
  // so albeit a bit counterintuitive but when it is NaN -> the value is actually VALID
  return (value <= MAX_ALLOWED_INT && value >= 0) || Number.isNaN(value)
}

const isEmptyValue = (value: any): boolean => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '') ||
    (typeof value === 'number' && Number.isNaN(value))
  )
}

const isInvalidNumberValue = (value: any): boolean => {
  return !validateValue(value) || isEmptyValue(value)
}

const isValidYear = (value: any): boolean => {
  if (isInvalidNumberValue(value)) {
    return false
  }

  return value >= 1900 && value <= new Date().getFullYear()
}

const formatFieldValue = (fieldValue: any): number | null => {
  return fieldValue === '-' || fieldValue === null || Number.isNaN(fieldValue) || fieldValue === ''
    ? null
    : parseInt(fieldValue)
}

const formatNaNNumber = (value: number): number => {
  return Number.isNaN(value) ? 0 : value
}

/**
 * Calculates total value of an array by field.
 *
 * @param array array.
 * @param field field to calculate the total within the array.
 * @return {number} the total value
 */
const sumBy = <T>(array: T[], field: keyof T): number => {
  return (
    array?.reduce((prev, curr) => prev + (curr?.[field] ? formatNaNNumber(parseInt(curr?.[field] as string)) : 0), 0) ??
    0
  )
}

/**
 * Calculates total value of an array of numbers.
 *
 * @param array array.
 * @param field field to calculate the total within the array.
 * @return {number} the total value
 */
const sum = <T extends number | undefined | null>(array: T[]): number => {
  return array?.reduce((prev, curr) => prev + (curr ? formatNaNNumber(curr) : 0), 0) ?? 0
}

export const DataGridUtils = {
  validateValue,
  isEmptyValue,
  isValidYear,
  isInvalidNumberValue,
  formatFieldValue,
  formatNaNNumber,
  sumBy,
  sum,
}
